import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import GridInfoItem from '../GridInfoItem';

const useStyles = makeStyles(() => ({
  items: {
    backgroundColor: 'rgba(118, 80, 160, 0.17)',
    borderLeft: '10px solid #7650a0',
  },
}));

export default function ClientInfoGrid({ client }) {
  const classes = useStyles();

  return (
    <Grid container className={classes.items} spacing={0} wrap="nowrap">
      <GridInfoItem name="Client" value={client.name} />
      <GridInfoItem
        name="Billing Address"
        value={`${client.billingAddressLine1} ${client.billingAddressLine2 || ''}`}
      />
      <GridInfoItem name="City" value={client.billingAddressCity} />
      <GridInfoItem name="State" value={client.billingAddressState} />
      <GridInfoItem name="Zip" value={client.billingAddressZip} />
    </Grid>
  );
}

ClientInfoGrid.propTypes = {
  client: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    billingAddressLine1: PropTypes.string,
    billingAddressLine2: PropTypes.string,
    billingAddressCity: PropTypes.string,
    billingAddressState: PropTypes.string,
    billingAddressZip: PropTypes.string,
  }).isRequired,
};
